import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatCardModule} from '@angular/material/card';

import { SharedModule } from 'src/app/components/shared.module';
import { LoginComponent } from './login/login.component';
import { ChangePassComponent } from './change-pass/change-pass.component';
import { RegisterComponent } from './register/register.component';
import { CasosComponent } from './casos/casos.component';
import { ComponentsModule } from '../newComponents/components.module';
import { FaqsComponent } from './faqs/faqs.component';
import { PerfilComponent } from './perfil/perfil.component';
import { ProductosComponent } from './productos/productos.component';
import { ConfiguracionComponent } from './configuracion/configuracion.component';
import { NuevoCasoComponent } from './nuevo-caso/nuevo-caso.component';
import { MatSelectModule } from '@angular/material/select';
import { PhotoCaptureComponent } from './nuevo-caso/photo-capture/photo-capture.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CasoDetailComponent } from './caso-detail/caso-detail.component';
import { SeguimientoComponent } from './seguimiento/seguimiento.component';
import { ActivateClientComponent } from './activate-client/activate-client.component';
import { CitasComponent } from './citas/citas.component';
import { AccesoSinRegistroComponent } from './acceso-sin-registro/acceso-sin-registro.component';
import { AvisoLegalComponent } from './aviso-legal/aviso-legal.component';
import { PoliticaPrivacidadComponent } from './politica-privacidad/politica-privacidad.component';
import { TerminosCondicionesAppComponent } from './terminos-condiciones-app/terminos-condiciones-app.component';
import { TerminosCondicionesWebComponent } from './terminos-condiciones-web/terminos-condiciones-web.component';
import { AccesoSinRegistroWebComponent } from './acceso-sin-registro-web/acceso-sin-registro.component';
import { CasoDetailWebComponent } from './caso-detail-web/caso-detail.component';
import { PoliticaCookiesComponent } from './politica-cookies/politica-cookies.component';
import { TranslocoModule } from '@ngneat/transloco';
import { CasoVerifyComponent } from './caso-verify/caso-verify.component';

@NgModule({
  declarations: [
    LoginComponent,
    ChangePassComponent,
    RegisterComponent,
    CasosComponent,
    FaqsComponent,
    PerfilComponent,
    ProductosComponent,
    ConfiguracionComponent,
    NuevoCasoComponent,
    PhotoCaptureComponent,
    CasoDetailComponent,
    CasoDetailWebComponent,
    SeguimientoComponent,
    ActivateClientComponent,
    CitasComponent,
    AccesoSinRegistroComponent,
    AvisoLegalComponent,
    PoliticaPrivacidadComponent,
    TerminosCondicionesAppComponent,
    TerminosCondicionesWebComponent,
    AccesoSinRegistroWebComponent,
    PoliticaCookiesComponent,
    CasoVerifyComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatSelectModule,
    MatCardModule,
    SharedModule,
    ComponentsModule,
    MatDialogModule,
    MatFormFieldModule,
    TranslocoModule
  ],
})
export class PagesModule { }
